/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography } from '@coursera/cds-core';

import { getPartnerLogosForCSCollectionLandingPage } from 'bundles/coursera-plus/components/constants';

import _t from 'i18n!nls/coursera-plus-landing-page';

const useStyles = () => {
  return {
    wrapper: css`
      width: 100%;
      background-color: #f5f5f5;
      padding-bottom: var(--cds-spacing-400);
      padding-top: var(--cds-spacing-400);
    `,
    container: css`
      max-width: 1200px;
      padding: 20px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: var(--cds-spacing-400);
    `,
    header: css`
      font-size: 28px;
    `,
    logoWrapper: css`
      width: 100%;
    `,
    logoList: css`
      margin: 0;
      padding: 0;
      display: flex;
      list-style-type: none;
      gap: var(--cds-spacing-400);
      flex-wrap: wrap;
      justify-content: space-around;
      align-items: center;

      @media (max-width: 365px) {
        flex-direction: column;
      }

      @media (max-width: 950px) {
        li {
          flex-basis: 40%;
          text-align: center;
        }
      }
    `,
  };
};

const CollectionPartnerLogos = () => {
  const partnerLogos = getPartnerLogosForCSCollectionLandingPage();
  const styles = useStyles();

  return (
    <div css={styles.wrapper}>
      <Grid container direction="column" css={styles.container}>
        <Typography variant="h2semibold" component="h2" css={styles.header}>
          {_t('Learn from the best')}
        </Typography>
        <Grid item direction="row" sm={8} css={styles.logoWrapper}>
          <ul css={styles.logoList}>
            {partnerLogos.map((logo) => (
              <li key={logo.id}>
                <Imgix src={logo.image} alt={logo.title} maxHeight={logo.height} />
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>
    </div>
  );
};

export default CollectionPartnerLogos;
